import React from "react";
import {
  Stack,
  Dropdown,
  DatePicker,
  PrimaryButton,
  IDropdownOption,
  DayOfWeek,
  DefaultButton,
  Checkbox,
  TooltipHost,
  Breadcrumb,
  Callout,
  DirectionalHint,
} from "office-ui-fabric-react";
import {
  childrenGap,
  EVEN_SHIFT,
  UPS_STATUS,
  READ_AT_TIME_FORMAT,
  childrenGap8,
} from "../../common/Constants";
import {
  ISearchTransformer,
  IDataCenter,
  ITransformerReading,
  IReadingStatus,
} from "../../../vm";
import {
  getTransformerReadings,
  updateTransformerReadingStatus,
} from "../../../services/infrastructure/TransformerService";
import { ToastContext } from "../../common/ToastProvider";
import {
  getADataCenter,
  getPowerComponents,
} from "../../../services/datacenter/DatacenterService";
import moment from "moment";
import { useParams, useHistory } from "react-router-dom";
import NoDataTile from "../../common/NoDataTile";
import { Loading } from "../../../services/Loading";
import { ConfirmDialogContext } from "../../common/ConfirmDialogProvider";
import Icon from "@mdi/react";
import {
  mdiCheck,
  mdiChevronLeft,
  mdiChevronRight,
  mdiClose,
  mdiDotsVertical,
  mdiPencil,
} from "@mdi/js";
import {
  getThreshold,
  isInThreshold,
  isValueLessThanThreshold,
} from "../../../services/ThresholdService";
import ManageTransformerDialog from "./ManageTransformerDialog";
import ManageAllRejectDialog from "../../common/ManageAllRejectDialog";
import ShowThresholdIcon from "../../common/ShowThresholdIcon";

export interface TransFormerMainProps { }

const TransformerMain: React.FC<TransFormerMainProps> = () => {
  //state
  const [state, setState] = React.useState({
    isLoading: false,
    isDatacenterFound: false,
    isTransformerLoaded: false,
    transformerList: [],
    allTransformerDropdownList: [],
    datacenter: undefined,
    serchObj: { datacenterId: "", date: new Date(), transformerId: "" },
    transformerReading: [],
    isIndeterminate: false,
    isAllChecked: false,
    selectedItems: [],
    transformerObj: {},
    manageTransformerDialog: {
      isOpen: false,
      index: undefined,
      data: undefined,
    },
    threshold: undefined,
    manageRejectDialog: {
      isOpen: false,
      ids: [],
      remarks: "",
    },
    manageActionsCallout: {
      isOpen: false,
      element: undefined,
      data: undefined,
    },
  } as {
    isLoading: boolean;
    isDatacenterFound: boolean;
    isTransformerLoaded: boolean;
    transformerList: any[];
    allTransformerDropdownList: IDropdownOption[];
    datacenter?: IDataCenter;
    serchObj: ISearchTransformer;
    transformerReading: ITransformerReading[];
    isIndeterminate: boolean;
    isAllChecked: boolean;
    selectedItems: string[];
    transformerObj: any;
    manageTransformerDialog: {
      isOpen: boolean;
      index?: number;
      data?: ITransformerReading;
    };
    threshold?: any;
    manageRejectDialog: {
      isOpen: boolean;
      ids: string[];
      remarks?: string;
    };
    manageActionsCallout: {
      isOpen: boolean;
      element: any;
      data?: ITransformerReading;
    };
  });

  //hooks
  const { showToast } = React.useContext(ToastContext);
  const { showConfirmDialog } = React.useContext(ConfirmDialogContext);
  const params: any = useParams();
  const history = useHistory();

  React.useEffect(() => {
    const asyncFunc = async () => {
      if (params.dataCenterId) {
        getDataCenter(params.dataCenterId);
      }
    };
    asyncFunc();
    console.log("state", state);
  }, []);

  const getDataCenter = async (datacenterId: string) => {
    setState({ ...state, isLoading: true });
    let result = await getADataCenter(datacenterId);
    if (result?.success) {
      setState({
        ...state,
        datacenter: result.data,
        isDatacenterFound: true,
        isLoading: false,
      });
      getThresholdData(result.data);
    } else {
      showToast(result?.message || "Error while getting datacenter", "error");
      setState({ ...state, isDatacenterFound: false, isLoading: false });
    }
  };

  const getThresholdData = async (datacenter: IDataCenter) => {
    setState({ ...state, isLoading: true });
    let result = await getThreshold("transformer");
    if (result?.success) {
      getPowerComponentsList(datacenter, result.data.threshold);
    } else {
      showToast(result?.message || "Error while getting datacenter", "error");
      setState({ ...state, isDatacenterFound: false, isLoading: false });
    }
  };

  const getPowerComponentsList = async (
    datacenter: IDataCenter,
    threshold?: any
  ) => {
    setState({ ...state, isLoading: true });
    let result = await getPowerComponents({
      datacenterId: params.dataCenterId,
      types: ["transformer"],
    });
    if (result?.success) {
      console.log("dd", result);

      let options: IDropdownOption[] = [];
      result.data.forEach((ele) => {
        options.push({
          key: ele._id,
          text: ele.name,
          data: {
            transformerType: ele?.transformerType || undefined,
          },
        });
      });
      let obj = {
        ...state,
        transformerList: result.data,
        isLoading: false,
        datacenter,
        isDatacenterFound: true,
        serchObj: {
          datacenterId: params.dataCenterId,
          date: new Date(),
          transformerId: options.length > 0 ? (options[0].key as string) : "",
          type:
            options.length > 0 && options[0].data?.transformerType
              ? options[0].data.transformerType
              : "oil",
        },
        allTransformerDropdownList: options,
        threshold,
      };
      setState(obj);
      getTransformerReadingsData(obj);
    } else {
      showToast(
        result?.message || "Error while getting transformer list",
        "error"
      );
      setState({ ...state, isLoading: false });
    }
  };

  const getTransformerReadingsData = async (paramState?: any) => {
    let localState = { ...state };
    if (paramState != null) {
      localState = { ...paramState };
    }

    setState({ ...localState, isLoading: true });
    let obj = { ...localState.serchObj };
    obj.date = moment(obj.date).format("YYYY-MM-DD");
    let result = await getTransformerReadings(obj);
    console.log("data", result);

    if (result?.success) {
      setState({
        ...localState,
        transformerReading: result.data,
        isLoading: false,
        isTransformerLoaded: true,
      });
    } else {
      showToast(
        result?.message || "Error while getting transformer readings",
        "error"
      );
      setState({ ...state, isLoading: false, isTransformerLoaded: false });
    }
  };

  const onSearch = async () => {
    if (!state.serchObj.transformerId) {
      showToast("Please select an transformer before searching", "error");
    }
    getTransformerReadingsData();
  };

  const handleAcceptOrRejectSelected = (isAccept: boolean) => {
    if (isAccept) {
      showConfirmDialog(
        "Are You Sure",
        `Do you want to ${isAccept ? "Accept" : "Reject"
        } selected transformer reading`,
        async () => {
          let selectedItems = [...state.selectedItems];
          let transformerReading = [...state.transformerReading];
          setState({ ...state, isLoading: true });
          let obj: IReadingStatus = {
            ids: selectedItems,
            status: isAccept ? "approved" : "rejected",
          };
          let result = await updateTransformerReadingStatus(obj);
          if (result?.success) {
            selectedItems.forEach((item) => {
              let index = transformerReading.findIndex(
                (ele) => ele._id === item
              );
              if (index !== -1) {
                transformerReading[index].status = isAccept
                  ? "approved"
                  : "rejected";
              }
            });
            showToast(
              `Transformer Reading ${isAccept ? "approved" : "rejected"
              } successfully`,
              "success"
            );
            setState({
              ...state,
              transformerReading,
              selectedItems: [],
              isLoading: false,
            });
          } else {
            showToast(
              result?.message ||
              `An error occurred while ${isAccept ? "approving" : "rejecting"
              } a transformer reading`,
              "error"
            );
            setState({
              ...state,
              isLoading: false,
            });
          }
        }
      );
    } else {
      let selectedItems = [...state.selectedItems];
      handleRejectAllOpenDialog(selectedItems);
    }
  };

  const onSelectAll = (isAllChecked: boolean) => {
    let selectedItems: string[] = [];
    if (isAllChecked) {
      state.transformerReading.forEach((ele) => {
        if (ele.status === "submitted") {
          selectedItems.push(ele._id as string);
        }
      });
      setState({ ...state, isAllChecked: true, selectedItems });
    } else {
      setState({ ...state, isAllChecked: false, selectedItems });
    }
  };

  const onIndividualSelect = (id: string) => {
    let selectedItems = [...state.selectedItems];
    let index = selectedItems.findIndex((e) => e === id);
    if (index === -1) {
      selectedItems.push(id);
    } else {
      selectedItems.splice(index, 1);
    }
    let isAllChecked = true;
    state.transformerReading.forEach((ele) => {
      if (
        ele.status === "submitted" &&
        selectedItems.includes(ele._id as string) === false
      ) {
        isAllChecked = false;
      }
    });
    setState({ ...state, selectedItems, isAllChecked });
  };

  const handleAcceptOrReject = (id: string, isAccept: boolean) => {
    showConfirmDialog(
      "Are You Sure",
      `Do you want to ${isAccept ? "Accept" : "Reject"
      } the transformer reading`,
      async () => {
        setState({
          ...state,
          isLoading: true,
          manageActionsCallout: {
            isOpen: false,
            element: undefined,
            data: undefined,
          },
        });
        let obj: IReadingStatus = {
          ids: [id],
          status: isAccept ? "approved" : "rejected",
        };
        let result = await updateTransformerReadingStatus(obj);
        if (result.success) {
          let transformerReading = [...state.transformerReading];
          let index = transformerReading.findIndex((ele) => ele._id === id);
          if (index !== -1) {
            transformerReading[index].status = isAccept
              ? "approved"
              : "rejected";
          }
          showToast(
            `Transformer Reading ${isAccept ? "approved" : "rejected"
            } successfully`,
            "success"
          );
          let selectedItems = [...state.selectedItems];
          if (state.isAllChecked) {
            let indx = selectedItems.findIndex((e) => e === id);
            selectedItems.splice(indx, 1);
          }
          setState({
            ...state,
            transformerReading,
            selectedItems,
            isLoading: false,
            manageActionsCallout: {
              isOpen: false,
              element: undefined,
              data: undefined,
            },
          });
        } else {
          showToast(
            result?.message ||
            `An error occurred while ${isAccept ? "approving" : "rejecting"
            } a transformer reading`,
            "error"
          );
          setState({
            ...state,
            isLoading: false,
            manageActionsCallout: {
              isOpen: false,
              element: undefined,
              data: undefined,
            },
          });
        }
      }
    );
  };

  const getMinValue = (property: string) => {
    let a = property.split(".");
    if (state.transformerReading.length > 0) {
      let list = state.transformerReading.map((ele: any) => {
        if (a[1]) {
          return ele[a[0]] ? ele[a[0]][a[1]] : "";
        } else {
          return ele[a[0]];
        }
      });
      if (property === "oilLevel") {
        if (list.includes("1/4")) {
          return "1/4";
        } else if (list.includes("1/2")) {
          return "1/2";
        } else {
          return "3/4";
        }
      } else {
        return Math.min(...list);
      }
    } else {
      return "";
    }
  };

  const getMaxValue = (property: string) => {
    let a = property.split(".");
    if (state.transformerReading.length > 0) {
      let list = state.transformerReading.map((ele: any) => {
        if (a[1]) {
          return ele[a[0]] ? ele[a[0]][a[1]] : "";
        } else {
          return ele[a[0]];
        }
      });
      if (property === "oilLevel") {
        if (list.includes("3/4")) {
          return "3/4";
        } else if (list.includes("1/2")) {
          return "1/2";
        } else {
          return "1/4";
        }
      } else {
        return Math.max(...list);
      }
    } else {
      return "";
    }
  };

  const onNextOrPrevFunc = (isPrev: boolean) => {
    let localState = { ...state };

    let currentSelectedTransformer = localState.serchObj.transformerId;
    let currentTransformerList = localState.allTransformerDropdownList;

    let currentIndex = currentTransformerList.findIndex(
      (d) => d.key === currentSelectedTransformer
    );

    if (isPrev) {
      if (currentIndex !== 0) {
        localState = {
          ...localState,
          serchObj: {
            ...localState.serchObj,
            transformerId: currentTransformerList[currentIndex - 1]
              .key as string,
            type:
              currentTransformerList[currentIndex - 1].data.transformerType ||
              "oil",
          },
        };
      }
    } else {
      if (currentIndex !== currentTransformerList.length - 1) {
        localState = {
          ...localState,
          serchObj: {
            ...localState.serchObj,
            transformerId: currentTransformerList[currentIndex + 1]
              .key as string,
            type:
              currentTransformerList[currentIndex + 1].data.transformerType ||
              "oil",
          },
        };
      }
    }
    getTransformerReadingsData(localState);
  };

  const handleDialogOpen = (isOpen: boolean, id?: string) => {
    let transformerReading = undefined;
    let index = undefined;
    if (id !== undefined) {
      index = state.transformerReading.findIndex((ele) => ele._id === id);
      transformerReading = { ...state.transformerReading[index] };
    }
    setState({
      ...state,
      manageTransformerDialog: {
        isOpen: isOpen,
        index: index,
        data: transformerReading,
      },
    });
  };

  const handleDialogClose = (data: ITransformerReading) => {
    let transformerReading = [...state.transformerReading];
    if (data) {
      if (state.manageTransformerDialog.index !== undefined) {
        transformerReading[state.manageTransformerDialog.index] = data;
      }
    }
    setState({
      ...state,
      manageTransformerDialog: {
        isOpen: false,
        index: undefined,
        data: undefined,
      },
      transformerReading,
    });
  };

  const handleRejectAllOpenDialog = (ids: string[]) => {
    setState({
      ...state,
      manageRejectDialog: {
        isOpen: true,
        ids: ids || [],
        remarks: "",
      },
    });
  };
  const handleRejectOpenDialog = (id: string, remarks?: string) => {
    setState({
      ...state,
      manageRejectDialog: {
        isOpen: true,
        ids: [id],
        remarks: remarks || "",
      },
    });
  };

  const handleRejectCloseDialog = async (
    isSuccess: boolean,
    remarks?: string
  ) => {
    let transformerReading = [...state.transformerReading];
    let selectedItems: string[] = state.manageRejectDialog.ids;
    if (isSuccess) {
      setState({
        ...state,
        isLoading: true,
      });
      let obj: IReadingStatus = {
        ids: selectedItems,
        status: "rejected",
        remarks: remarks || "",
      };
      let result = await updateTransformerReadingStatus(obj);
      if (result?.success) {
        selectedItems.forEach((item) => {
          let index = transformerReading.findIndex((ele) => ele._id === item);
          if (index !== -1) {
            transformerReading[index].status = "rejected";
            transformerReading[index].remarks = remarks || "";
          }
        });
        showToast(`Transformer Reading rejected successfully`, "success");
        setState({
          ...state,
          transformerReading,
          selectedItems: [],
          manageRejectDialog: {
            isOpen: false,
            ids: [],
            remarks: undefined,
          },
          isLoading: false,
        });
      } else {
        showToast(
          result?.message ||
          `An error occurred while rejecting a transformer reading`,
          "error"
        );
        setState({
          ...state,
          manageRejectDialog: {
            isOpen: false,
            ids: [],
            remarks: undefined,
          },
          isLoading: false,
        });
      }
    } else {
      setState({
        ...state,
        manageRejectDialog: {
          isOpen: false,
          ids: [],
          remarks: undefined,
        },
        transformerReading,
      });
    }
  };

  const handleLoading = () => {
    setState({
      ...state,
      isLoading: !state.isLoading,
    });
  };

  const handleCallOutOpenClose = (
    isOpen: boolean,
    ele?: React.MouseEvent<HTMLSpanElement>,
    data?: ITransformerReading
  ) => {
    setState({
      ...state,
      manageActionsCallout: {
        isOpen,
        element: isOpen ? ele?.currentTarget : undefined,
        data,
      },
    });
  };

  let type = "oil";
  if (state.transformerReading.length > 0) {
    type = state.transformerReading[0].transformerType;
  } else {
    type = state.serchObj.type as string;
  }
  console.log("type", type);

  return (
    <React.Fragment>
      {state.isLoading && <Loading />}
      {state.isDatacenterFound ? (
        <React.Fragment>
          <Stack>
            <Stack.Item>
              {/* <Text variant="xLarge">
                Transformer Readings -{" "}
                {state.datacenter && state.datacenter.name}{" "}
                {state.datacenter && state.datacenter.location && " - "}
                {state.datacenter && state.datacenter.location}
              </Text> */}
              <Breadcrumb
                items={[
                  {
                    text: state.datacenter
                      ? state.datacenter.name
                      : "Datacenter",
                    key: "datacenter",
                  },
                  {
                    text: "Infrastructures",
                    key: "infrastructure",
                    onClick: () => {
                      history.goBack();
                    },
                  },
                  {
                    text: "Transformer Readings",
                    key: "trfmr-readings",
                    isCurrentItem: true,
                  },
                ]}
              />
            </Stack.Item>
          </Stack>
          <br />
          <Stack horizontal horizontalAlign="start">
            <Stack.Item>
              <Stack horizontal wrap tokens={childrenGap}>
                <Stack.Item>
                  <Dropdown
                    placeholder="Select a Transformer"
                    selectedKey={state.serchObj.transformerId}
                    styles={{ dropdown: { width: 200 } }}
                    options={state.allTransformerDropdownList}
                    onChange={(e, v: IDropdownOption | undefined) => {
                      if (v) {
                        setState({
                          ...state,
                          serchObj: {
                            ...state.serchObj,
                            transformerId: v.key as string,
                            type: v.data?.transformerType || "oil",
                          },
                        });
                      }
                    }}
                  />
                </Stack.Item>
                <Stack.Item>
                  <DatePicker
                    firstDayOfWeek={DayOfWeek.Sunday}
                    showMonthPickerAsOverlay={true}
                    value={new Date(state.serchObj.date)}
                    showGoToToday={false}
                    onSelectDate={(date: Date | null | undefined) =>
                      setState({
                        ...state,
                        serchObj: { ...state.serchObj, date: date as Date },
                      })
                    }
                    placeholder="Select a date..."
                    ariaLabel="Select a date"
                    styles={{ root: { width: 200 } }}
                  />
                </Stack.Item>
                <Stack.Item>
                  <PrimaryButton text="Search" onClick={() => onSearch()} />
                </Stack.Item>
              </Stack>
            </Stack.Item>
            {/* <Stack.Item>
              <DefaultButton
                text="Accept"
                disabled={state.selectedItems.length === 0}
                onClick={() => handleAcceptOrRejectSelected(true)}
              />
              &nbsp;&nbsp;
              <DefaultButton
                text="Reject"
                disabled={state.selectedItems.length === 0}
                onClick={() => handleAcceptOrRejectSelected(false)}
              />
            </Stack.Item> */}
          </Stack>
          <br />
          <Stack horizontal horizontalAlign="space-between" wrap>
            <Stack.Item className="ml-6">
              <span
                onClick={
                  state.allTransformerDropdownList.length < 1 ||
                    state.allTransformerDropdownList[0]?.key ===
                    state.serchObj.transformerId
                    ? undefined
                    : () => onNextOrPrevFunc(true)
                }
                className={
                  state.allTransformerDropdownList.length < 1 ||
                    state.allTransformerDropdownList[0]?.key ===
                    state.serchObj.transformerId
                    ? "btn-disabled"
                    : "btn-enabled pointer"
                }
              >
                <Icon
                  path={mdiChevronLeft}
                  size={0.9}
                  className="btnIcon"
                  style={{
                    marginBottom: -6,
                    marginRight: -8,
                    color: "#135c8a",
                  }}
                />
                <DefaultButton
                  text="Previous Transformer"
                  className="borderless-btn"
                // disabled={
                //     state.allTransformerDropdownList[0].key ===
                //     state.serchObj.transformerId
                //   }
                // onClick={() => {
                //   onNextOrPrevFunc(true);
                // }}
                />
              </span>
              <span className="nxt-prv-btn-border"></span>
              <span
                onClick={
                  state.allTransformerDropdownList.length < 1 ||
                    state.allTransformerDropdownList[
                      state.allTransformerDropdownList.length - 1
                    ]?.key === state.serchObj.transformerId
                    ? undefined
                    : () => onNextOrPrevFunc(false)
                }
                className={
                  state.allTransformerDropdownList.length < 1 ||
                    state.allTransformerDropdownList[
                      state.allTransformerDropdownList.length - 1
                    ]?.key === state.serchObj.transformerId
                    ? "btn-disabled"
                    : "btn-enabled pointer"
                }
              >
                <DefaultButton
                  text="Next Transformer"
                  // disabled={
                  //   state.allTransformerDropdownList[
                  //     state.allTransformerDropdownList.length - 1
                  //   ].key === state.serchObj.transformerId
                  // }
                  // onClick={() => {
                  //   onNextOrPrevFunc(false);
                  // }}
                  className="borderless-btn"
                />
                <Icon
                  path={mdiChevronRight}
                  size={0.9}
                  className="btnIcon"
                  style={{ marginBottom: -6, marginLeft: -8, color: "#135c8a" }}
                />
              </span>
            </Stack.Item>
            <Stack.Item>
              <DefaultButton
                text="Accept"
                className="mr-8 custom-secondary-btn"
                disabled={state.selectedItems.length === 0}
                onClick={() => handleAcceptOrRejectSelected(true)}
              />
              <DefaultButton
                text="Reject"
                disabled={state.selectedItems.length === 0}
                onClick={() => handleAcceptOrRejectSelected(false)}
                className="custom-secondary-btn"
              />
            </Stack.Item>
          </Stack>
          {/* <Stack horizontal horizontalAlign="end" wrap>
            <Stack.Item>
              <DefaultButton
                text="Accept"
                className="mr-8"
                disabled={state.selectedItems.length === 0}
                onClick={() => handleAcceptOrRejectSelected(true)}
              />
            </Stack.Item>
            <Stack.Item>
              <DefaultButton
                text="Reject"
                disabled={state.selectedItems.length === 0}
                onClick={() => handleAcceptOrRejectSelected(false)}
              />
            </Stack.Item>
          </Stack> */}
          <br />
          {state.isTransformerLoaded && (
            <Stack>
              <div className="office-table bg-white">
                <table className="ms-Table bordered-table w-100">
                  <thead className="html-table-thead">
                    <tr>
                      <th rowSpan={2}>
                        <Checkbox
                          checked={state.isAllChecked}
                          onChange={(eve, checked) =>
                            onSelectAll(checked as boolean)
                          }
                        />
                      </th>
                      <th rowSpan={2}>Time (Hrs)</th>
                      <th rowSpan={2}>System</th>
                      {/* <th colSpan={3}>LT VOLT</th>
                      <th rowSpan={2}>HT AMPS</th>
                      <th rowSpan={2}>LT AMPS</th>
                      <th rowSpan={2}>KVA</th>
                      <th rowSpan={2}>FREQ</th>
                      <th rowSpan={2}>KWH</th> */}
                      {type === "oil" && (
                        <>
                          <th rowSpan={2}>Winding Temp ℃</th>
                          <th rowSpan={2}>Oil Temp ℃</th>
                          {/* <th rowSpan={2}>TAP POSITION</th>
                    <th rowSpan={2}>OLTC COUNT</th> */}
                          <th rowSpan={2}>Oil Level in Conservator</th>
                          <th rowSpan={2}>Oil Leakage (If any)</th>
                          <th rowSpan={2}>Explosion Vent (Oil in Window)</th>
                          <th rowSpan={2}>Colour of Silica Gel</th>
                          <th rowSpan={2}>
                            No. of Counter (Tap Changer Counter)
                          </th>
                          <th colSpan={2}>RTCC Status</th>
                        </>
                      )}
                      {type === "dry" && (
                        <>
                          <th rowSpan={2}>Temp - Channel 1</th>
                          <th rowSpan={2}>Temp - Channel 2</th>
                          <th rowSpan={2}>Temp - Channel 3</th>
                          <th rowSpan={2}>Temp - Channel 4</th>
                          <th rowSpan={2}>Temp - Channel 5</th>
                          <th rowSpan={2}>Temp - Channel 6</th>
                        </>
                      )}
                      <th rowSpan={2}>Shift Tech Sign</th>
                      <th rowSpan={2}>Status</th>
                      <th rowSpan={2}>Remarks</th>
                      <th rowSpan={2}>Read At</th>
                      <th rowSpan={2}>Actions</th>
                    </tr>
                    {type === "oil" && (
                      <tr>
                        <th>Tap Position</th>
                        <th>Ref. Voltage</th>
                      </tr>
                    )}
                  </thead>
                  <tbody>
                    {EVEN_SHIFT.map((ele, index) => {
                      let item = state.transformerReading.find(
                        (e) => e.shiftTime === ele
                      );
                      return (
                        <tr key={index}>
                          <th>
                            <Checkbox
                              disabled={!item || item.status !== "submitted"}
                              checked={state.selectedItems.includes(
                                item?._id as string
                              )}
                              onChange={() =>
                                onIndividualSelect(item?._id as string)
                              }
                              className="ml-12"
                            />
                          </th>
                          <th>{ele}</th>
                          <td>
                            {item?.isSystemOn !== undefined
                              ? item?.isSystemOn === true
                                ? "On"
                                : "Off"
                              : ""}
                          </td>
                          {/* <td>{item?.ltVoltage.RY || ""}</td>
                          <td>{item?.ltVoltage.BR || ""}</td>
                          <td>{item?.ltVoltage.YB || ""}</td>
                          <td>{item?.htAmps || ""}</td>
                          <td>{item?.ltAmps || ""}</td>
                          <td>{item?.kva || ""}</td>
                          <td>{item?.frequency || ""}</td>
                          <td>{item?.kwh || ""}</td> */}
                          {type === "oil" && (
                            <>
                              <td
                                className={
                                  isInThreshold(
                                    item?.windTemperature || "",
                                    "windTemperature",
                                    state.threshold
                                  )
                                    ? "text-danger"
                                    : ""
                                }
                              >
                                {item?.windTemperature || ""}
                                {isInThreshold(
                                  item?.windTemperature || "",
                                  "windTemperature",
                                  state.threshold
                                ) && (
                                    <ShowThresholdIcon
                                      isLessThan={
                                        isValueLessThanThreshold(
                                          item?.windTemperature || "",
                                          "windTemperature",
                                          state.threshold
                                        ) as boolean
                                      }
                                    />
                                  )}
                              </td>
                              <td
                                className={
                                  isInThreshold(
                                    item?.oilTemperature || "",
                                    "oilTemperature",
                                    state.threshold
                                  )
                                    ? "text-danger"
                                    : ""
                                }
                              >
                                {item?.oilTemperature || ""}
                                {isInThreshold(
                                  item?.oilTemperature || "",
                                  "oilTemperature",
                                  state.threshold
                                ) && (
                                    <ShowThresholdIcon
                                      isLessThan={
                                        isValueLessThanThreshold(
                                          item?.oilTemperature || "",
                                          "oilTemperature",
                                          state.threshold
                                        ) as boolean
                                      }
                                    />
                                  )}
                              </td>
                              {/* <td>{item?.tapPosition || ""}</td>
                          <td>{item?.oltcCount || ""}</td> */}
                              <td>{item?.oilLevel || ""}</td>
                              <td>
                                {item?.oilLeakage !== undefined
                                  ? item?.oilLeakage === true
                                    ? "Yes"
                                    : "No"
                                  : ""}
                              </td>
                              <td>
                                {item?.explosionVent !== undefined
                                  ? item?.explosionVent === true
                                    ? "Yes"
                                    : "No"
                                  : ""}
                              </td>
                              <td>
                                {item?.colourOfSilicaGen !== undefined
                                  ? item?.colourOfSilicaGen === "blue"
                                    ? "Blue"
                                    : "Pink"
                                  : ""}
                              </td>
                              <td
                                className={
                                  isInThreshold(
                                    item?.noOfCounter || "",
                                    "noOfCounter",
                                    state.threshold
                                  )
                                    ? "text-danger"
                                    : ""
                                }
                              >
                                {item?.noOfCounter || ""}
                                {isInThreshold(
                                  item?.noOfCounter || "",
                                  "noOfCounter",
                                  state.threshold
                                ) && (
                                    <ShowThresholdIcon
                                      isLessThan={
                                        isValueLessThanThreshold(
                                          item?.noOfCounter || "",
                                          "noOfCounter",
                                          state.threshold
                                        ) as boolean
                                      }
                                    />
                                  )}
                              </td>
                              <td
                                className={
                                  isInThreshold(
                                    item?.rtccStatus?.tapPosition || "",
                                    "rtccStatus.tapPosition",
                                    state.threshold
                                  )
                                    ? "text-danger"
                                    : ""
                                }
                              >
                                {item?.rtccStatus?.tapPosition || ""}
                                {isInThreshold(
                                  item?.rtccStatus?.tapPosition || "",
                                  "rtccStatus.tapPosition",
                                  state.threshold
                                ) && (
                                    <ShowThresholdIcon
                                      isLessThan={
                                        isValueLessThanThreshold(
                                          item?.rtccStatus?.tapPosition || "",
                                          "rtccStatus.tapPosition",
                                          state.threshold
                                        ) as boolean
                                      }
                                    />
                                  )}
                              </td>
                              <td
                                className={
                                  isInThreshold(
                                    item?.rtccStatus?.refVoltage || "",
                                    "rtccStatus.refVoltage",
                                    state.threshold
                                  )
                                    ? "text-danger"
                                    : ""
                                }
                              >
                                {item?.rtccStatus?.refVoltage || ""}
                                {isInThreshold(
                                  item?.rtccStatus?.refVoltage || "",
                                  "rtccStatus.refVoltage",
                                  state.threshold
                                ) && (
                                    <ShowThresholdIcon
                                      isLessThan={
                                        isValueLessThanThreshold(
                                          item?.rtccStatus?.refVoltage || "",
                                          "rtccStatus.refVoltage",
                                          state.threshold
                                        ) as boolean
                                      }
                                    />
                                  )}
                              </td>
                            </>
                          )}
                          {type === "dry" && (
                            <>
                              <td
                                className={
                                  isInThreshold(
                                    item?.channel1Temp || "",
                                    "channel1Temp",
                                    state.threshold
                                  )
                                    ? "text-danger"
                                    : ""
                                }
                              >
                                {item?.channel1Temp || ""}
                                {isInThreshold(
                                  item?.channel1Temp || "",
                                  "channel1Temp",
                                  state.threshold
                                ) && (
                                    <ShowThresholdIcon
                                      isLessThan={
                                        isValueLessThanThreshold(
                                          item?.channel1Temp || "",
                                          "channel1Temp",
                                          state.threshold
                                        ) as boolean
                                      }
                                    />
                                  )}
                              </td>
                              <td
                                className={
                                  isInThreshold(
                                    item?.channel2Temp || "",
                                    "channel2Temp",
                                    state.threshold
                                  )
                                    ? "text-danger"
                                    : ""
                                }
                              >
                                {item?.channel2Temp || ""}
                                {isInThreshold(
                                  item?.channel2Temp || "",
                                  "channel2Temp",
                                  state.threshold
                                ) && (
                                    <ShowThresholdIcon
                                      isLessThan={
                                        isValueLessThanThreshold(
                                          item?.channel2Temp || "",
                                          "channel2Temp",
                                          state.threshold
                                        ) as boolean
                                      }
                                    />
                                  )}
                              </td>
                              <td
                                className={
                                  isInThreshold(
                                    item?.channel3Temp || "",
                                    "channel3Temp",
                                    state.threshold
                                  )
                                    ? "text-danger"
                                    : ""
                                }
                              >
                                {item?.channel3Temp || ""}
                                {isInThreshold(
                                  item?.channel3Temp || "",
                                  "channel3Temp",
                                  state.threshold
                                ) && (
                                    <ShowThresholdIcon
                                      isLessThan={
                                        isValueLessThanThreshold(
                                          item?.channel3Temp || "",
                                          "channel3Temp",
                                          state.threshold
                                        ) as boolean
                                      }
                                    />
                                  )}
                              </td>
                              <td
                                className={
                                  isInThreshold(
                                    item?.channel4Temp || "",
                                    "channel4Temp",
                                    state.threshold
                                  )
                                    ? "text-danger"
                                    : ""
                                }
                              >
                                {item?.channel4Temp || ""}
                                {isInThreshold(
                                  item?.channel4Temp || "",
                                  "channel4Temp",
                                  state.threshold
                                ) && (
                                    <ShowThresholdIcon
                                      isLessThan={
                                        isValueLessThanThreshold(
                                          item?.channel4Temp || "",
                                          "channel4Temp",
                                          state.threshold
                                        ) as boolean
                                      }
                                    />
                                  )}
                              </td>
                              <td
                                className={
                                  isInThreshold(
                                    item?.channel5Temp || "",
                                    "channel5Temp",
                                    state.threshold
                                  )
                                    ? "text-danger"
                                    : ""
                                }
                              >
                                {item?.channel5Temp || ""}
                                {isInThreshold(
                                  item?.channel5Temp || "",
                                  "channel5Temp",
                                  state.threshold
                                ) && (
                                    <ShowThresholdIcon
                                      isLessThan={
                                        isValueLessThanThreshold(
                                          item?.channel5Temp || "",
                                          "channel5Temp",
                                          state.threshold
                                        ) as boolean
                                      }
                                    />
                                  )}
                              </td>
                              <td
                                className={
                                  isInThreshold(
                                    item?.channel6Temp || "",
                                    "channel6Temp",
                                    state.threshold
                                  )
                                    ? "text-danger"
                                    : ""
                                }
                              >
                                {item?.channel6Temp || ""}
                                {isInThreshold(
                                  item?.channel6Temp || "",
                                  "channel6Temp",
                                  state.threshold
                                ) && (
                                    <ShowThresholdIcon
                                      isLessThan={
                                        isValueLessThanThreshold(
                                          item?.channel6Temp || "",
                                          "channel6Temp",
                                          state.threshold
                                        ) as boolean
                                      }
                                    />
                                  )}
                              </td>
                            </>
                          )}
                          <td>{item?.recordedBy || ""}</td>
                          <td>
                            {item && item.status ? UPS_STATUS[item.status] : ""}
                          </td>
                          <td>{item?.remarks || ""}</td>
                          <td>
                            {item?.date
                              ? moment(item.date).format(READ_AT_TIME_FORMAT)
                              : ""}
                          </td>
                          <td align="center" className="no-wrap">
                            {item && item?.status === "submitted" && (
                              <span
                                onClick={(ele) =>
                                  handleCallOutOpenClose(true, ele, item)
                                }
                              >
                                <Icon
                                  path={mdiDotsVertical}
                                  size={0.9}
                                  className="pointer"
                                  color="#135c8a"
                                />
                              </span>
                              // <React.Fragment>
                              //   <TooltipHost
                              //     content="Update"
                              //     calloutProps={{ gapSpace: 0 }}
                              //   >
                              //     <span
                              //       onClick={() =>
                              //         handleDialogOpen(
                              //           true,
                              //           item?._id as string
                              //         )
                              //       }
                              //     >
                              //       <Icon
                              //         path={mdiPencil}
                              //         size={0.7}
                              //         className="pointer"
                              //       />
                              //     </span>
                              //   </TooltipHost>
                              //   &nbsp;&nbsp;
                              //   <TooltipHost
                              //     content="Accept"
                              //     calloutProps={{ gapSpace: 0 }}
                              //   >
                              //     <span
                              //       onClick={() =>
                              //         handleAcceptOrReject(
                              //           item?._id as string,
                              //           true
                              //         )
                              //       }
                              //     >
                              //       <Icon
                              //         path={mdiCheck}
                              //         size={0.8}
                              //         className="pointer"
                              //         color="green"
                              //       />
                              //     </span>
                              //   </TooltipHost>
                              //   &nbsp;&nbsp;
                              //   <TooltipHost
                              //     content="Reject"
                              //     calloutProps={{ gapSpace: 0 }}
                              //   >
                              //     <span
                              //       onClick={() =>
                              //         handleRejectOpenDialog(
                              //           item?._id as string,
                              //           item?.remarks
                              //         )
                              //       }
                              //     >
                              //       <Icon
                              //         path={mdiClose}
                              //         size={0.8}
                              //         className="pointer"
                              //         color="red"
                              //       />
                              //     </span>
                              //   </TooltipHost>
                              // </React.Fragment>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                    <tr>
                      <td></td>
                      <th>Min Value</th>
                      <td></td>
                      {/* <td>{getMinValue("ltVoltage.RY")}</td>
                      <td>{getMinValue("ltVoltage.BR")}</td>
                      <td>{getMinValue("ltVoltage.YB")}</td>
                      <td>{getMinValue("htAmps")}</td>
                      <td>{getMinValue("ltAmps")}</td>
                      <td>{getMinValue("kva")}</td>
                      <td>{getMinValue("frequency")}</td>
                      <td>{getMinValue("kwh")}</td> */}
                      {type === "oil" && (
                        <>
                          <td>{getMinValue("windTemperature")}</td>
                          <td>{getMinValue("oilTemperature")}</td>
                          {/* <td>{getMinValue("tapPosition")}</td>
                      <td>{getMinValue("oltcCount")}</td> */}
                          <td>{getMinValue("oilLevel")}</td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td>{getMinValue("noOfCounter")}</td>
                          <td>{getMinValue("rtccStatus.tapPosition")}</td>
                          <td>{getMinValue("rtccStatus.refVoltage")}</td>
                        </>
                      )}
                      {type === "dry" && (
                        <>
                          <td>{getMinValue("channel1Temp")}</td>
                          <td>{getMinValue("channel2Temp")}</td>
                          <td>{getMinValue("channel3Temp")}</td>
                          <td>{getMinValue("channel4Temp")}</td>
                          <td>{getMinValue("channel5Temp")}</td>
                          <td>{getMinValue("channel6Temp")}</td>
                        </>
                      )}
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td></td>
                      <th>Max Value</th>
                      <td></td>
                      {/* <td>{getMinValue("ltVoltage.RY")}</td>
                      <td>{getMinValue("ltVoltage.BR")}</td>
                      <td>{getMinValue("ltVoltage.YB")}</td>
                      <td>{getMinValue("htAmps")}</td>
                      <td>{getMinValue("ltAmps")}</td>
                      <td>{getMinValue("kva")}</td>
                      <td>{getMinValue("frequency")}</td>
                      <td>{getMinValue("kwh")}</td> */}
                      {type === "oil" && (
                        <>
                          <td>{getMaxValue("windTemperature")}</td>
                          <td>{getMaxValue("oilTemperature")}</td>
                          {/* <td>{getMinValue("tapPosition")}</td>
                          <td>{getMinValue("oltcCount")}</td> */}
                          <td>{getMaxValue("oilLevel")}</td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td>{getMaxValue("noOfCounter")}</td>
                          <td>{getMaxValue("rtccStatus.tapPosition")}</td>
                          <td>{getMaxValue("rtccStatus.refVoltage")}</td>
                        </>
                      )}
                      {type === "dry" && (
                        <>
                          <td>{getMaxValue("channel1Temp")}</td>
                          <td>{getMaxValue("channel2Temp")}</td>
                          <td>{getMaxValue("channel3Temp")}</td>
                          <td>{getMaxValue("channel4Temp")}</td>
                          <td>{getMaxValue("channel5Temp")}</td>
                          <td>{getMaxValue("channel6Temp")}</td>
                        </>
                      )}
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              {/* <div className="next-prev-btn">
                <div>
                  <DefaultButton
                    text="Previous Transformer"
                    className="mr-8"
                    disabled={
                      state.allTransformerDropdownList[0].key ===
                      state.serchObj.transformerId
                    }
                    onClick={() => {
                      onNextOrPrevFunc(true);
                    }}
                  />
                  <DefaultButton
                    text="Next Transformer"
                    disabled={
                      state.allTransformerDropdownList[
                        state.allTransformerDropdownList.length - 1
                      ].key === state.serchObj.transformerId
                    }
                    onClick={() => {
                      onNextOrPrevFunc(false);
                    }}
                  />
                </div>
              </div> */}
            </Stack>
          )}
        </React.Fragment>
      ) : (
        <NoDataTile
          title="No Datacenter Found"
          description="Datacenter either deleted or not created"
        />
      )}
      {state.manageActionsCallout.isOpen && (
        <Callout
          styles={{ root: { width: 95, padding: 20 } }}
          role="alertdialog"
          ariaLabelledBy={
            state.manageActionsCallout && state.manageActionsCallout.data?._id
          }
          gapSpace={0}
          target={state.manageActionsCallout.element}
          directionalHint={DirectionalHint.leftCenter}
          onDismiss={() => handleCallOutOpenClose(false)}
        // setInitialFocus={true}
        >
          <Stack tokens={childrenGap8}>
            <Stack.Item className="pointer">
              <span
                onClick={() =>
                  handleDialogOpen(
                    true,
                    state.manageActionsCallout.data?._id as string
                  )
                }
                className="callout-options"
              >
                Edit
              </span>
            </Stack.Item>
            <Stack.Item className="pointer">
              <span
                onClick={() =>
                  handleAcceptOrReject(
                    state.manageActionsCallout.data?._id as string,
                    true
                  )
                }
                className="callout-options"
              >
                Accept
              </span>
            </Stack.Item>
            <Stack.Item className="pointer">
              <span
                onClick={() =>
                  handleRejectOpenDialog(
                    state.manageActionsCallout.data?._id as string,
                    state.manageActionsCallout.data?.remarks
                  )
                }
                className="callout-options"
              >
                Reject
              </span>
            </Stack.Item>
          </Stack>
        </Callout>
      )}
      {state.manageTransformerDialog.isOpen && (
        <ManageTransformerDialog
          data={state.manageTransformerDialog.data}
          handleLoading={handleLoading}
          handleDialogClose={(data: ITransformerReading) =>
            handleDialogClose(data)
          }
          threshold={state.threshold}
        />
      )}
      {state.manageRejectDialog.isOpen && (
        <ManageAllRejectDialog
          handleRejectCloseDialog={(isSuccess: boolean, remarks?: string) =>
            handleRejectCloseDialog(isSuccess, remarks)
          }
          remarks={state.manageRejectDialog.remarks}
          subText="transformer reading"
        />
      )}
    </React.Fragment>
  );
};

export default TransformerMain;
